












import { defineComponent, PropType, SetupContext } from '@vue/composition-api';

export default defineComponent({

  props: {
    value: { type: Boolean as PropType<boolean>, required: true }
  },

  setup (props, ctx: SetupContext) {

    function input (value: boolean) {
      ctx.emit('input', value);
    }

    function done () {
      ctx.emit('done');
    }

    return {
      input,
      done
    };
  }
});
